import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { AttendanceCodeConfigProvider } from "./context/attendanceCodeConfigContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AttendanceCodeConfigProvider>
    <App />
  </AttendanceCodeConfigProvider>
);
